// React Router Components
import { Routes, Route, Navigate } from "react-router-dom";

import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
// Layouts
import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import LandingLayout from "layouts/Landing";
import KnowledgebaseLayout from "layouts/KbLayout";

// Auth
import PersistLogin from "components/PersistLogin";
import RequireAuth from "components/RequireAuth";

// Hooks
import useLastLocation from "hooks/useLastLocation";
// Theme
import customTheme from "theme/theme.js";
import Terms from "views/Pages/Terms";

export default function App() {
  useLastLocation();
  return (
    <ChakraProvider theme={customTheme} resetCss={false}>
      <ColorModeScript initialColorMode={customTheme.config.initialColorMode} />
      <Routes>
        <Route path="/auth/*" element={<AuthLayout />} />
        <Route path="*" element={<Navigate to="/admin/dashboard" />} />
        <Route
          path="/auth/email-blast-tool"
          element={<Navigate to="/admin/dashboard" />}
        />
        <Route path="/auth/SignIn/" element={<Navigate to="/auth/sign-in" />} />
        <Route path="/terms/" element={<Terms />} />
        <Route element={<PersistLogin />}>
          <Route element={<RequireAuth allowedRoles={["User"]} />}>
            <Route
              path="/landing/knowledgebase/*"
              element={<KnowledgebaseLayout />}
            />
            <Route path="/landing/*" element={<LandingLayout />} />
            <Route path="/admin/*" element={<AdminLayout />} />
          </Route>
        </Route>
      </Routes>
    </ChakraProvider>
  );
}
